import React, { useState } from 'react';
import './App.css';

function App() {
  const [name, setName] = useState<string>('');
  const [response, setResponse] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!name) {
      setResponse('Please enter a name.');
      return;
    }

    setIsLoading(true);
    setResponse('');

    try {
      // REACT_APP_API_URL controls where API calls go:
      //   - Local dev: set REACT_APP_API_URL=http://localhost:8080 (see below)
      //   - Production (CloudFront): leave unset — uses relative URL since frontend and API share the same domain
      const apiBaseUrl = process.env.REACT_APP_API_URL ?? '';
      const apiEndpoint = `${apiBaseUrl}/api/hello?name=${encodeURIComponent(name)}`;
      
      const res = await fetch(apiEndpoint);
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      // The Go backend returns a JSON with a "message" field
      const data = await res.json();
      setResponse(data.message);

    } catch (error) {
      console.error("Failed to fetch from API:", error);
      if (error instanceof Error) {
        setResponse(`Error: ${error.message}`);
      } else {
        setResponse('An unknown error occurred.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Two-Tier App Demo</h1>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter your name"
            style={{ padding: '10px', fontSize: '16px' }}
          />
          <button 
            type="submit" 
            disabled={isLoading}
            style={{ padding: '10px 20px', fontSize: '16px', marginLeft: '10px' }}
          >
            {isLoading ? 'Sending...' : 'Say Hello'}
          </button>
        </form>
        {response && (
          <p style={{ marginTop: '20px', fontSize: '20px' }}>
            Server says: <strong>{response}</strong>
          </p>
        )}
      </header>
    </div>
  );
}

export default App;